import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TableSkeleton = _resolveComponent("TableSkeleton");
  return $props.loading ? (_openBlock(), _createBlock(_component_TableSkeleton, {
    key: 0,
    headers: ['', '', '', '', '', '', '']
  })) : _renderSlot(_ctx.$slots, "default", {
    key: 1
  });
}